import React, { useContext } from "react";
import { SocialButton } from "@monorepo/components";
import { SignAuth0Context } from "../../Auth0Context";

import "./FacebookButton.scss";
import logo from "../facebook_logo.svg";

import { pushDataToSegment, saveLastAttemptInfo } from "../../segmentData";
import {
  SIGN_IN_ATTEMPT,
  ACCOUNT_CREATION_ATTEMPT,
  SIGN_IN_SUCCESS,
  ACCOUNT_CREATION_SUCCESS,
  SIGN_IN_PAGE,
  ACCOUNT_CREATION_PAGE
} from "../../constant";

interface FacebookButtonProps {
  id?: string;
  title: string;
  imgAlt: string;
  wrappedProps?: any;
}

export const FacebookButtonControl: React.FunctionComponent<FacebookButtonProps> = ({
  id,
  title,
  wrappedProps,
  imgAlt
}) => {
  const auth0 = useContext(SignAuth0Context);

  const onFacebookPressed = (): void => {
    saveLastAttemptInfo({ label: "Facebook" });
    if (id && id.includes("signUp")) {
      pushDataToSegment(ACCOUNT_CREATION_ATTEMPT, false, { label: "Facebook", pageName: ACCOUNT_CREATION_PAGE });
    } else {
      pushDataToSegment(SIGN_IN_ATTEMPT, false, { label: "Facebook", pageName: SIGN_IN_PAGE });
    }

    auth0.authenticateFacebook();

    if (id && id.includes("signUp")) {
      // we would always send succeeded (there’s no chance of failure, it’s just redirecting the user away)
      pushDataToSegment(ACCOUNT_CREATION_SUCCESS, false, { label: "Facebook", pageName: ACCOUNT_CREATION_PAGE });
    } else {
      pushDataToSegment(SIGN_IN_SUCCESS, false, { label: "Facebook", pageName: SIGN_IN_PAGE });
    }
  };

  return (
    <SocialButton
      id={id === undefined ? "facebook" : id}
      wrappedProps={wrappedProps}
      title={title}
      imgSrc={logo}
      imgAlt={imgAlt}
      onPressed={onFacebookPressed}
    ></SocialButton>
  );
};

const FacebookButton: React.FunctionComponent<FacebookButtonProps> = React.memo(
  FacebookButtonControl
);
export default FacebookButton;
